
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TemplateRuleInput from "./TemplateRuleInput.vue";
import defensiveCopy from "@/util/defensive-copy";
import { RuleGroup, Rule, Condition } from "@/types/conditions";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    IconButton,
    NiceButton,
    Icon,
    TemplateRuleInput
  }
})
export default class TemplateRuleGroupInput extends Vue {
  @Prop()
  ruleGroup!: RuleGroup;

  @Prop()
  availableConditions!: Condition[];

  @Prop()
  templateTypes!: string[];

  get usedConditions(): Condition[] {
    const usedConditions = this.ruleGroup.map(rule => rule.ruleSlug);
    return this.availableConditions.filter(condition =>
      usedConditions.includes(condition.slug)
    );
  }

  addEmptyRule() {
    const ruleGroup = defensiveCopy(this.ruleGroup);

    ruleGroup.push({});

    this.$emit("input", ruleGroup);
  }

  deleteRule(ruleIndex: number) {
    const ruleGroup = defensiveCopy(this.ruleGroup);
    ruleGroup.splice(ruleIndex, 1);

    if (ruleGroup.length === 0) {
      this.deleteGroup();
    } else {
      this.$emit("input", ruleGroup);
    }
  }

  editRule(rule: Rule, ruleIndex: number) {
    const ruleGroup = defensiveCopy(this.ruleGroup);
    ruleGroup[ruleIndex] = rule;
    this.$emit("input", ruleGroup);
  }

  deleteGroup() {
    this.$emit("deleteGroup");
  }
}
